/* eslint-disable max-classes-per-file */
import { IMapGeometryWicket } from "../../../map.settings";

export class Fastighet {
    uuid: string;
    fastighetsbeteckning: string;
    trakt: string;
    kommun: string;
    block: string;
    enhet: number;
    tecken: string;
    fastighetsagare: Fastighetsagare[];
    constructor() {
        this.fastighetsagare = [];
    }
}

export class Fastighetsagare {
    adress: FastighetsagareAdress;
    andelNamnare: number;
    andelTaljare: number;
    efternamn: string;
    folkbokforingsadress: FastighetsagareAdress;
    fornamn: string;
    namn: string;
    personOrgNummer: string;
    typ: string;
}

export class FastighetsagareAdress {
    postnummer: string;
    postort: string;
    utdelningsadress: string[];
}

export class FastighetGeometry {
    fastighet: Fastighet;
    geometry: IMapGeometryWicket;
    timestamp: Date;

    constructor(fastighet: Fastighet, geometry: IMapGeometryWicket) {
        this.fastighet = fastighet;
        this.geometry = geometry;
        this.timestamp = new Date();
    }
}

export class PersonOrganisationsnummerStatusDto {
    personOrganisationsnummer: string;
    leverantorer: OrgnrVirkesleverantorDto[];
}

export class OrgnrVirkesleverantorDto {
    namn: string;
    id: number;
    limeId: string;
    typAvKontakt: string;
    aktiv: boolean;
}
